<script setup>
import { ref, onMounted , defineExpose, defineEmits, nextTick } from "vue"
import vtc from "@/helpers/vtc.js";

const emit = defineEmits(["add-item"])
const newItem = ref({ Name: "", Price: 0, Description: "", IdType:0 })

let modalInstance = null

// initialize bootstrap modal
onMounted(async () => {
  await nextTick() // ensure DOM is rendered
  const modalEl = document.getElementById("mdlNewQuote")
  modalInstance = new window.bootstrap.Modal(modalEl)
})

// open method (called from parent)
const open = () => {
  modalInstance?.show()
  getTypes()
}

const types = ref([])
const getTypes = async() =>{
    const res = await  vtc.vtcFetch(`/Quote/GetQuoteItemTypes`, null, "API2")
    if (!res.error){
        types.value = res        
    }    
}

function onTypeSelected() {
  const selected = types.value.find(t => t.id === newItem.value.IdType)
  console.log({selected})
  if (selected) {
    newItem.value.Description = selected.summaryTemplate
  }
}

// close method
const close = () => {
  modalInstance?.hide()
}

// called when user clicks "Add to Quote"
const addItemFromMdl = () => {
  if(!newItem.value.IdType){
    alert('Select a type')
    return false;
  }
  emit("add-item", { ...newItem.value })
  newItem.value = { Name: "", Price: 0, Description: "",IdType:0 } // reset
  close()
}

// expose open() so parent can call it
defineExpose({ open })
</script>

<template>
  <div class="modal fade" id="mdlNewQuote" tabindex="-1">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Item</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-sm-3 modspec_font12">Name</div>
            <div class="col-sm-6">
              <input type="text" class="form-control" v-model="newItem.Name" />
            </div>
          </div>

            <div class="row mt-3">
            <div class="col-sm-3 mt-3 modspec_font12">Type</div>
            <div class="col-sm-9">
                <select 
                class="form-select" 
                v-model="newItem.IdType"
                @change="onTypeSelected"
                >
                <option disabled value="">-- Select a type --</option>
                <option 
                    v-for="t in types" 
                    :key="t.id" 
                    :value="t.id"
                >
                    {{ t.name }}
                </option>
                </select>
            </div>
            </div>


          <div class="row mt-3">
            <div class="col-sm-3 mt-3 modspec_font12">Total Price</div>
            <div class="col-sm-6">
              <input type="number" class="form-control" v-model="newItem.Price" />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-sm-3 mt-3 modspec_font12">Description</div>
            <div class="col-sm-9">
                <textarea 
                class="form-control" 
                v-model="newItem.Description" 
                rows="4"
                ></textarea>
            </div>
         </div>

        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-primary" @click="addItemFromMdl">
            Add to Quote
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
